"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AuthException_1 = __importDefault(require("../Exception/AuthException"));
class AuthAndProfile {
    constructor(api, tokenService, cache, client) {
        this.saveResponse = async (response) => {
            await this.tokenService.setNew({
                token: response.token,
                refreshToken: response.refreshToken,
                expiresIn: response.expiresIn,
            });
        };
        this.isAuth = async () => {
            try {
                await this.tokenService.getValidToken();
                return true;
            }
            catch (e) {
                return false;
            }
        };
        this.logout = async () => {
            await this.tokenService.unset();
            return this.cache.clear();
        };
        this.auth = async (refreshToken) => {
            await this.tokenService.setNew({
                token: "",
                refreshToken,
                expiresIn: -1, // assume it already expired
            });
            try {
                await this.tokenService.getValidToken();
            }
            catch (e) {
                await this.tokenService.setNew(null);
                throw e;
            }
        };
        this.tokenService = tokenService;
        this.api = api;
        this.cache = cache;
        this.requestPasswordChange = this.api.requestPasswordChange;
        this.client = client;
    }
    async isCoach() {
        const { data: { user: { isCoach }, }, } = await this.client.post("/graphql", {
            operationName: "isUserCoach",
            query: "query isCoach { user { isCoach } }",
        });
        if (!isCoach) {
            return false;
        }
        return true;
    }
    async logIn(credentials) {
        try {
            const response = await this.client.logIn(credentials);
            await this.saveResponse(response);
            if (!(await this.isCoach())) {
                await this.tokenService.setNew(null);
                throw new AuthException_1.default();
            }
        }
        catch (e) {
            if (e instanceof Error) {
                throw new AuthException_1.default(e);
            }
        }
    }
    async changePassword(oldPassword, newPassword, newPasswordRepeated) {
        return this.api.changePassword(oldPassword, newPassword, newPasswordRepeated);
    }
}
exports.default = AuthAndProfile;
//# sourceMappingURL=AuthAndProfile.js.map